import { useDesign } from "../state/designStore";

export function RenderingToast() {
  const { isRendering, renderError } = useDesign();

  const visible = isRendering || !!renderError;
  const isError = !!renderError && !isRendering;

  return (
    <div
      className={`fixed top-3 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-full shadow-lg text-sm font-medium flex items-center gap-2 transition-all duration-200 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"
      } ${isError ? "bg-red-500 text-white" : "bg-tg-secondaryBg text-tg-text"}`}
      role="status"
      aria-live="polite"
    >
      {!isError && (
        <span className="w-3.5 h-3.5 rounded-full border-2 border-tg-hint border-t-tg-button animate-spin" />
      )}
      <span>{isError ? renderError : "جاري التحديث..."}</span>
    </div>
  );
}